angular.module('zc.master.projects', [
  'zc.master'
  # TODO: remove requirement
  'zc.projects'
  'flow'
])




// WEBPACK FOOTER //
// ./src/master_admin_modules/master.projects/index.js.coffee